import React from "react";

export function HeaderItem(props: any) {
  function handleClick() {
    if (props.onClick) props.onClick({ ...props });
  }
  return (
    <div
      className={props.className}
      style={{ display: "flex", alignItems: "center" }}
      onClick={handleClick}
    >
      {props.image && (
        <div
          className={props.className + "-image"}
          style={{
            backgroundImage: `url(${props.image})`,
            paddingRight: "5px",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      )}
      <div className={props.className + "-text"}>{props.title}</div>
    </div>
  );
}
